import React, { Component } from "react";
import {
  Grid as Container,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl
} from "react-bootstrap";

import Button from "components/CustomButton/CustomButton.jsx";
import ViewportAlert from "components/ViewportAlert/ViewportAlert";

const API_URL = "https://hgsystem.pl/mangusta/notifications.php";
const PUSH_API_URL = "/push-api/";
const ALARM_TYPES = [
  { code: 0, label: "Awaria czujnika temperatury" },
  { code: 1, label: "Awaria czujnika objętości" },
  { code: 2, label: "Brak postępu chłodzenia" },
  { code: 3, label: "Zbyt wolne chłodzenie" },
  { code: 4, label: "Przekroczony czas osiągnięcia temperatury docelowej" },
  { code: 5, label: "Zbyt długo podwyższona temperatura przechowywania" },
  { code: 6, label: "Wysoka temperatura przechowywania" },
  { code: 7, label: "Krytyczna temperatura przechowywania" },
  { code: 8, label: "Wzrost temperatury podczas przechowywania" },
  { code: 9, label: "Przekroczony dług cieplny" },
  { code: 10, label: "Nieoczekiwany ubytek mleka" },
  { code: 11, label: "Nie wykryto mycia" },
  { code: 12, label: "Zbyt niska maksymalna temperatura mycia" },
  { code: 13, label: "Zbyt krótka gorąca faza mycia" },
  { code: 14, label: "Zbyt niska temperatura końcowa mycia" },
  { code: 15, label: "Dój podczas mycia" },
  { code: 16, label: "Mycie nie kończy się prawidłowo" }
];
const ALL_ALARM_CODES = ALARM_TYPES.map(alarm => alarm.code);

function urlBase64ToUint8Array(value) {
  const padding = "=".repeat((4 - (value.length % 4)) % 4);
  const base64 = (value + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from(Array.prototype.map.call(raw, char => char.charCodeAt(0)));
}

class Notifications extends Component {
  state = {
    loading: true,
    saving: false,
    error: "",
    message: "",
    email: "",
    emailConfigured: false,
    pushAvailable: false,
    pushSupported:
      "serviceWorker" in navigator &&
      "PushManager" in window &&
      "Notification" in window,
    pushBusy: false,
    pushPermission:
      "Notification" in window ? Notification.permission : "unsupported",
    vapidPublicKey: "",
    currentPushSubscription: null,
    pushSubscriptions: [],
    queue: {},
    preferences: {
      email_enabled: false,
      push_enabled: false,
      minimum_severity: 2,
      notify_raised: true,
      notify_resolved: false,
      email_fallback_minutes: 15,
      alarm_codes: ALL_ALARM_CODES
    }
  };

  componentDidMount() {
    this.load();
    this.loadPush();
  }

  post = body => {
    if (!this.props.credentials)
      return Promise.reject(new Error("Brak danych uwierzytelniających."));
    return fetch(API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...body,
        auth: this.props.credentials
      })
    }).then(response =>
      response.json().then(payload => {
        if (!response.ok || !payload.ok)
          throw new Error(payload.error || `Błąd HTTP ${response.status}`);
        return payload;
      })
    );
  };

  pushPost = body => {
    if (!this.props.credentials)
      return Promise.reject(new Error("Brak danych uwierzytelniających."));
    return fetch(PUSH_API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...body,
        auth: this.props.credentials
      })
    }).then(response =>
      response.json().then(payload => {
        if (!response.ok || !payload.ok)
          throw new Error(
            payload.error ||
              (payload.errors && payload.errors[0]) ||
              `Błąd HTTP ${response.status}`
          );
        return payload;
      })
    );
  };

  applyResponse = payload => {
    this.setState({
      loading: false,
      saving: false,
      email: payload.email || "",
      emailConfigured: payload.email_configured === true,
      queue: payload.queue || {},
      preferences: {
        ...this.state.preferences,
        ...(payload.preferences || {})
      }
    });
  };

  load = () => {
    this.setState({ loading: true, error: "" });
    this.post({ action: "get" })
      .then(this.applyResponse)
      .catch(error =>
        this.setState({ loading: false, error: error.message || String(error) })
      );
  };

  loadPush = () => {
    if (!this.state.pushSupported) return;
    Promise.all([
      this.pushPost({ action: "status" }),
      navigator.serviceWorker.ready.then(registration =>
        registration.pushManager.getSubscription()
      )
    ])
      .then(([payload, subscription]) => {
        this.setState({
          pushAvailable: true,
          vapidPublicKey: payload.vapid_public_key || "",
          pushSubscriptions: payload.subscriptions || [],
          currentPushSubscription: subscription,
          pushPermission: Notification.permission
        });
      })
      .catch(error =>
        this.setState({
          pushAvailable: false,
          error: error.message || String(error)
        })
      );
  };

  enablePush = () => {
    this.setState({ pushBusy: true, error: "", message: "" });
    let registration;
    navigator.serviceWorker.ready
      .then(value => {
        registration = value;
        return Notification.requestPermission();
      })
      .then(permission => {
        if (permission !== "granted")
          throw new Error("Przeglądarka nie udzieliła zgody na powiadomienia.");
        return registration.pushManager.getSubscription();
      })
      .then(existing => {
        if (existing) return existing;
        return registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(
            this.state.vapidPublicKey
          )
        });
      })
      .then(subscription =>
        this.pushPost({
          action: "subscribe",
          subscription: subscription.toJSON()
        }).then(payload => ({ payload, subscription }))
      )
      .then(({ payload, subscription }) =>
        this.setState({
          pushBusy: false,
          pushAvailable: true,
          pushPermission: Notification.permission,
          currentPushSubscription: subscription,
          pushSubscriptions: payload.subscriptions || [],
          message:
            payload.message ||
            "Powiadomienia PUSH zostały włączone na tym urządzeniu."
        })
      )
      .catch(error =>
        this.setState({
          pushBusy: false,
          pushPermission:
            "Notification" in window
              ? Notification.permission
              : "unsupported",
          error: error.message || String(error)
        })
      );
  };

  disablePush = () => {
    const subscription = this.state.currentPushSubscription;
    if (!subscription) return;
    this.setState({ pushBusy: true, error: "", message: "" });
    this.pushPost({
      action: "unsubscribe",
      endpoint: subscription.endpoint
    })
      .then(payload =>
        subscription.unsubscribe().then(() => {
          this.setState({
            pushBusy: false,
            currentPushSubscription: null,
            pushSubscriptions: payload.subscriptions || [],
            message:
              payload.message ||
              "Powiadomienia PUSH wyłączono na tym urządzeniu."
          });
        })
      )
      .catch(error =>
        this.setState({
          pushBusy: false,
          error: error.message || String(error)
        })
      );
  };

  testPush = scope => {
    const subscription = this.state.currentPushSubscription;
    if (scope === "current" && !subscription) return;
    this.setState({ pushBusy: true, error: "", message: "" });
    this.pushPost({
      action: "test",
      scope,
      endpoint: subscription ? subscription.endpoint : undefined
    })
      .then(payload =>
        this.setState({
          pushBusy: false,
          message: payload.message || "Test PUSH został wysłany."
        })
      )
      .catch(error =>
        this.setState({
          pushBusy: false,
          error: error.message || String(error)
        })
      );
  };

  formatPushDate = value => {
    const timestamp = Number(value);
    if (!Number.isFinite(timestamp) || timestamp <= 0) return "—";
    return new Date(timestamp * 1000).toLocaleString("pl-PL");
  };

  setPreference = (field, value) => {
    this.setState(previousState => ({
      preferences: {
        ...previousState.preferences,
        [field]: value
      }
    }));
  };

  save = event => {
    event.preventDefault();
    const preferences = this.state.preferences;
    this.setState({ saving: true, error: "", message: "" });
    this.post({
      action: "save",
      email_enabled: Boolean(preferences.email_enabled),
      minimum_severity: Number(preferences.minimum_severity),
      notify_raised: Boolean(preferences.notify_raised),
      notify_resolved: Boolean(preferences.notify_resolved),
      email_fallback_minutes: Number(preferences.email_fallback_minutes),
      alarm_codes: Array.isArray(preferences.alarm_codes)
        ? preferences.alarm_codes
        : ALL_ALARM_CODES
    })
      .then(payload => {
        this.applyResponse(payload);
        this.setState({
          message: payload.message || "Ustawienia powiadomień zapisano."
        });
      })
      .catch(error =>
        this.setState({
          saving: false,
          error: error.message || String(error)
        })
      );
  };

  renderCheckbox(label, field, disabled) {
    const checked = Boolean(this.state.preferences[field]);
    return (
      <div className="checkbox">
        <input
          id={`notification-${field}`}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={event => this.setPreference(field, event.target.checked)}
        />
        <label htmlFor={`notification-${field}`}>{label}</label>
      </div>
    );
  }

  setAllAlarmTypes = enabled => {
    this.setPreference("alarm_codes", enabled ? ALL_ALARM_CODES : []);
  };

  toggleAlarmType = (code, enabled) => {
    const current = Array.isArray(this.state.preferences.alarm_codes)
      ? this.state.preferences.alarm_codes
      : ALL_ALARM_CODES;
    this.setPreference(
      "alarm_codes",
      enabled
        ? Array.from(new Set(current.concat([code]))).sort((a, b) => a - b)
        : current.filter(value => value !== code)
    );
  };

  renderAlarmType = alarm => {
    const selected = Array.isArray(this.state.preferences.alarm_codes)
      ? this.state.preferences.alarm_codes
      : ALL_ALARM_CODES;
    return (
      <div className="checkbox" key={alarm.code}>
        <input
          id={`notification-alarm-${alarm.code}`}
          type="checkbox"
          checked={selected.indexOf(alarm.code) >= 0}
          onChange={event =>
            this.toggleAlarmType(alarm.code, event.target.checked)
          }
        />
        <label htmlFor={`notification-alarm-${alarm.code}`}>
          {alarm.label}
        </label>
      </div>
    );
  };

  render() {
    const {
      loading,
      saving,
      error,
      message,
      email,
      emailConfigured,
      pushAvailable,
      pushSupported,
      pushBusy,
      pushPermission,
      currentPushSubscription,
      pushSubscriptions,
      queue,
      preferences
    } = this.state;
    return (
      <div className="content">
        {error && (
          <ViewportAlert
            bsStyle="danger"
            onDismiss={() => this.setState({ error: "" })}
          >
            {error}
          </ViewportAlert>
        )}
        {message && (
          <ViewportAlert
            bsStyle="success"
            onDismiss={() => this.setState({ message: "" })}
          >
            {message}
          </ViewportAlert>
        )}
        <Container fluid>
          <Row>
            <Col md={8}>
              <div className="card">
                <div className="header">
                  <h4 className="title">Powiadomienia</h4>
                  <p className="category">
                    Wybierz, o których alarmach chcesz otrzymywać wiadomości.
                  </p>
                </div>
                <div className="content">
                  {loading ? (
                    <p>Ładowanie ustawień…</p>
                  ) : (
                    <form onSubmit={this.save}>
                      <h5>E-mail</h5>
                      {this.renderCheckbox(
                        `Wysyłaj powiadomienia na ${email || "adres konta"}`,
                        "email_enabled",
                        !emailConfigured || !email
                      )}
                      {!emailConfigured && (
                        <p className="text-danger">
                          Wysyłka SMTP nie jest obecnie skonfigurowana.
                        </p>
                      )}

                      <FormGroup>
                        <ControlLabel>Minimalny poziom alarmu</ControlLabel>
                        <FormControl
                          componentClass="select"
                          value={preferences.minimum_severity}
                          onChange={event =>
                            this.setPreference(
                              "minimum_severity",
                              Number(event.target.value)
                            )
                          }
                        >
                          <option value={0}>Informacyjny i wyższe</option>
                          <option value={1}>Ostrzeżenie i wyższe</option>
                          <option value={2}>Alarm i krytyczny</option>
                          <option value={3}>Tylko krytyczny</option>
                        </FormControl>
                      </FormGroup>

                      <h5>Zdarzenia</h5>
                      {this.renderCheckbox(
                        "Powiadamiaj o rozpoczęciu alarmu",
                        "notify_raised",
                        false
                      )}
                      {this.renderCheckbox(
                        "Powiadamiaj o zakończeniu alarmu",
                        "notify_resolved",
                        false
                      )}

                      <h5>Typy alarmów</h5>
                      <p className="text-muted">
                        Zaznacz alarmy, dla których mają być tworzone
                        powiadomienia e-mail i PUSH.
                      </p>
                      <p>
                        <Button
                          type="button"
                          bsSize="small"
                          onClick={() => this.setAllAlarmTypes(true)}
                        >
                          Zaznacz wszystkie
                        </Button>{" "}
                        <Button
                          type="button"
                          bsSize="small"
                          onClick={() => this.setAllAlarmTypes(false)}
                        >
                          Odznacz wszystkie
                        </Button>
                      </p>
                      <Row>
                        <Col sm={6}>
                          {ALARM_TYPES.slice(0, 9).map(this.renderAlarmType)}
                        </Col>
                        <Col sm={6}>
                          {ALARM_TYPES.slice(9).map(this.renderAlarmType)}
                        </Col>
                      </Row>

                      <Button
                        type="submit"
                        bsStyle="info"
                        fill
                        disabled={saving}
                      >
                        {saving ? "Zapisywanie…" : "Zapisz ustawienia"}
                      </Button>
                    </form>
                  )}
                </div>
              </div>
            </Col>
            <Col md={4}>
              <div className="card">
                <div className="header">
                  <h4 className="title">Web Push</h4>
                </div>
                <div className="content">
                  {!pushSupported ? (
                    <p className="text-danger">
                      Ta przeglądarka nie obsługuje Web Push.
                    </p>
                  ) : pushPermission === "denied" ? (
                    <p className="text-danger">
                      Powiadomienia są zablokowane w ustawieniach przeglądarki.
                    </p>
                  ) : currentPushSubscription ? (
                    <React.Fragment>
                      <p className="text-success">
                        PUSH jest aktywny na tym urządzeniu.
                      </p>
                      <Button
                        bsStyle="success"
                        block
                        disabled={pushBusy}
                        onClick={() => this.testPush("current")}
                      >
                        Wyślij test na to urządzenie
                      </Button>
                      <Button
                        bsStyle="info"
                        block
                        disabled={pushBusy || pushSubscriptions.length === 0}
                        onClick={() => this.testPush("all")}
                      >
                        Wyślij test na wszystkie moje urządzenia
                      </Button>
                      <Button
                        bsStyle="danger"
                        block
                        disabled={pushBusy}
                        onClick={this.disablePush}
                      >
                        Wyłącz PUSH na tym urządzeniu
                      </Button>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <p>
                        {pushAvailable
                          ? "Powiadomienia PUSH nie są jeszcze włączone na tym urządzeniu."
                          : "Łączenie z usługą Web Push…"}
                      </p>
                      <Button
                        bsStyle="info"
                        fill
                        block
                        disabled={pushBusy || !pushAvailable}
                        onClick={this.enablePush}
                      >
                        {pushBusy
                          ? "Włączanie…"
                          : "Włącz powiadomienia PUSH"}
                      </Button>
                    </React.Fragment>
                  )}
                  <p className="text-muted">
                    Na iPhone i iPad powiadomienia będą dostępne po dodaniu
                    aplikacji do ekranu początkowego.
                  </p>
                  <hr />
                  <strong>
                    Zarejestrowane urządzenia: {pushSubscriptions.length}
                  </strong>
                  {pushSubscriptions.length === 0 ? (
                    <p className="text-muted">Brak aktywnych subskrypcji.</p>
                  ) : (
                    pushSubscriptions.map(subscription => (
                      <div
                        key={subscription.id}
                        style={{
                          borderTop: "1px solid #eee",
                          paddingTop: 8,
                          marginTop: 8
                        }}
                      >
                        <div>
                          {subscription.user_agent || "Nieznana przeglądarka"}
                        </div>
                        <small className="text-muted">
                          Dodano:{" "}
                          {this.formatPushDate(subscription.created_at)}
                          <br />
                          Ostatni test:{" "}
                          {this.formatPushDate(subscription.last_success_at)}
                        </small>
                      </div>
                    ))
                  )}
                </div>
              </div>
              <div className="card">
                <div className="header">
                  <h4 className="title">Kolejka</h4>
                </div>
                <div className="content">
                  <p>Oczekujące: {queue.pending || 0}</p>
                  <p>Wysłane: {queue.sent || 0}</p>
                  <p>Nieudane: {queue.failed || 0}</p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Notifications;



// WEBPACK FOOTER //
// ./src/views/Notifications/Notifications.jsx